import Alert from "react-bootstrap/Alert";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Button from "react-bootstrap/Button";

function NoResult({ fillData }) {
  return (
    <div>
      <Alert className="text-center mt-3 brdr-rg-green px-4">
        <Row>
          <Alert.Heading>
            Unfortunately we were unable to find a matching tire size. Please
            contact us so that we can help you and others in the future!
          </Alert.Heading>
        </Row>
        <Row className="pt-md-2 pb-2">
          <Col>
            <Button
              href="https://rimguardsolutions.com/contact-us"
              target="_blank"
              rel="noopener noreferrer"
              className="text-center float-md-left mt-md-0 mt-3 btn-rg-purple"
            >
              Email Us
            </Button>
            <Col md className="text-md-left text-center">
              {/* <Col sm={12} md={6}> */}
              <Button
                href="tel:6166087745"
                target="_blank"
                rel="noopener noreferrer"
                className="text-center float-md-right mt-md-0 mt-3 btn-rg-purple"
                variant="success"
              >
                Call Us @ (616) 608-7745
              </Button>
            </Col>
          </Col>
        </Row>
      </Alert>
    </div>
  );
}

export default NoResult;
